import CSSOM from 'cssom';

// Angehängte Originalmail: nur <body> wird übernommen, die <style>-Regeln aus dem <head> (Outlook: p.MsoNormal
// {font-family:Calibri;font-size:11pt}, a:link, …) gingen dabei verloren. Vorher auf die Elemente schreiben,
// damit der Verlauf beim Empfänger so aussieht wie die Originalmail. Inline-Styles des Originals gewinnen.

// mso-margin-*-alt bleibt: daran erkennt der Email-Editor Outlooks automatischen Absatzabstand
const SKIPPED_PROPERTIES = /^(mso-(?!margin-(top|bottom)-alt)|page$|size$|behavior$)/i;

function specificity(selector) {
    const withoutNot = selector.replace(/:not\(([^)]*)\)/g, ' $1');
    const ids = (withoutNot.match(/#[\w-]+/g) || []).length;
    const classes = (withoutNot.match(/(\.[\w-]+|\[[^\]]+\]|:(?!:)[\w-]+)/g) || []).length;
    const tags = (withoutNot.replace(/(#[\w-]+|\.[\w-]+|\[[^\]]+\]|::?[\w-]+)/g, ' ').match(/(^|[\s>+~])[a-z][\w-]*/gi) || []).length;
    return ids * 10000 + classes * 100 + tags;
}

function collectRules(rules, result) {
    Array.from(rules || []).forEach(rule => {
        if (rule.selectorText && rule.style) {
            rule.selectorText.split(',').forEach(selector => {
                const trimmed = selector.trim();
                // Pseudo-Zustände (:hover, :link, ::before) lassen sich nicht inline abbilden
                if (trimmed && !/::?(hover|active|focus|visited|link|before|after|first-line|first-letter)/i.test(trimmed)) {
                    result.push({selector: trimmed, style: rule.style, order: result.length});
                }
            });
        }
    });
    return result;
}

// <style>-Regeln des Dokuments als Inline-Style auf die Elemente schreiben (auch auf <body>); true wenn Regeln griffen
export function applyStyleRules(doc) {
    const rules = [];
    doc.querySelectorAll('style').forEach(styleElement => {
        // Word: @list-/@page-Definitionen sind kein Standard-CSS und bringen den Parser aus dem Tritt
        const css = styleElement.textContent.replace(/<!--|-->/g, '').replace(/@(list|page)\b[^{]*\{[^}]*\}/gi, '');
        try {
            collectRules(CSSOM.parse(css).cssRules, rules);
        } catch (e) {
            // kaputtes CSS in fremden Mails: dann eben ohne
        }
    });
    if (!rules.length) {
        return false;
    }

    rules.sort((a, b) => specificity(a.selector) - specificity(b.selector) || a.order - b.order);

    // erst sammeln (spätere/spezifischere Regel gewinnt), dann einmal schreiben – Inline-Style des Originals zuletzt
    const computed = new Map();
    rules.forEach(rule => {
        let elements;
        try {
            elements = Array.from(doc.body.querySelectorAll(rule.selector));
            if (doc.body.matches(rule.selector)) {
                elements.unshift(doc.body);
            }
        } catch (e) {
            return;
        }
        elements.forEach(element => {
            if (!computed.has(element)) {
                computed.set(element, {});
            }
            const target = computed.get(element);
            for (let i = 0; i < rule.style.length; i++) {
                const property = rule.style[i];
                if (!SKIPPED_PROPERTIES.test(property)) {
                    target[property] = rule.style.getPropertyValue(property);
                }
            }
        });
    });

    computed.forEach((properties, element) => {
        const inline = element.getAttribute('style') || '';
        const inlineProperties = inline.split(';').map(item => item.split(':')[0].trim().toLowerCase()).filter(Boolean);
        const fromRules = Object.keys(properties)
            .filter(property => !inlineProperties.includes(property.toLowerCase()))
            .map(property => `${property}:${properties[property]}`);
        if (fromRules.length) {
            element.setAttribute('style', fromRules.join(';') + (inline ? ';' + inline : ''));
        }
    });

    return computed.size > 0;
}

export default function inlineQuoteStyles(doc) {
    if (!applyStyleRules(doc)) {
        return doc.body.innerHTML;
    }
    // <body> selbst wird nicht übernommen: seine Styles (Schrift, Farbe) auf einen Rahmen um den Inhalt legen
    const bodyStyle = doc.body.getAttribute('style');
    return bodyStyle
        ? `<div style="${bodyStyle.replace(/"/g, "'")}">${doc.body.innerHTML}</div>`
        : doc.body.innerHTML;
}
